<template>
  <div id="report-found-picture">
    <file-upload-content @onFileChange="handleChangeImg" />
    <!-- <file-uploader-vue
      class="upload"
      @onFileChange="handleChangeImg"
      :multifile="true"
    >
      <div class="upload-content flex-center">
        <div class="upload-btn">选择图片上传</div>
      </div>
    </file-uploader-vue> -->
    <ul class="picture">
      <li
        class="picture-content"
        v-for="item in reportDetail.photos"
        :key="item.inspectReportPhotoId"
      >
        <img :src="item.thumb" alt="" class="picture-img" />
        <span
          class="iconfont icon-shanchu1"
          @click="handleDelete(item.inspectReportPhotoId)"
        ></span>
        <div class="picture-ctrl">
          <div
            class="picture-ctrl__btn"
            :class="{ 'picture-ctrl__btn-active': item[selectItem.value] }"
            v-for="selectItem in options"
            :key="selectItem.value"
            @click="item[selectItem.value] = !item[selectItem.value]"
          >
            {{ selectItem.label }}
          </div>
        </div>
      </li>
      <li class="picture-content"></li>
    </ul>
  </div>
</template>

<script>
import { getFileDataURL } from '../../config/utils';
import FileUploadContent from '../layout/file-upload-content.vue';
// import fileUploaderVue from '../layout/file-uploader.vue';
export default {
  components: { FileUploadContent },
  props: {
    reportDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      options: [
        {
          value: 'zhuYaoLiMian',
          label: '主要立面'
        },
        {
          value: 'teSeGouJian',
          label: '特色构件'
        },
        {
          value: 'gaiDongBuWei',
          label: '改动部位'
        }
      ]
    };
  },
  methods: {
    /**
     * 监听建筑图片回调
     */
    handleChangeImg({ files }) {
      Array.from(files).forEach(async (item, index) => {
        const test = await getFileDataURL(item, 'image');
        const imgItem = {
          file: item,
          url: test,
          thumb: test,
          gaiDongBuWei: false,
          teSeGouJian: false,
          zhuYaoLiMian: false,
          inspectReportPhotoId: index + Date.now()
        };
        this.reportDetail.photos.push(imgItem);
      });
    },
    /**
     * 删除
     */
    handleDelete(id) {
      const deleteIndex = this.reportDetail.photos.findIndex((item, index) => {
        return item.inspectReportPhotoId == id;
      });
      this.reportDetail.photos.splice(deleteIndex, 1);
    }
  }
};
</script>

<style lang="scss">
#report-found-picture {
  .picture {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    margin-top: 20px;
    &-content {
      width: 195px;
      position: relative;
    }
    .icon-shanchu1 {
      position: absolute;
      top: -20px;
      right: -20px;
      font-size: 36px;
      color: $color-primary;
    }
    &-img {
      width: 195px;
      height: 140px;
    }
    &-ctrl {
      position: absolute;
      bottom: 0px;
      display: flex;
      justify-content: space-between;
      color: #fff;
      width: 195px;
      &__btn {
        width: 60px;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        background-color: rgba($color: #000, $alpha: 0.3);
        &-active {
          background-color: $color-primary !important;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #report-found-picture {
    .picture {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;
      margin-top: 20px;
      &-content {
        width: 50%;
        position: relative;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
      }
      .icon-shanchu1 {
        position: absolute;
        top: -15px;
        right: -10px;
        font-size: 36px;
        color: $color-primary;
      }
      &-img {
        width: 90%;
        height: 140px;
      }
      &-ctrl {
        position: absolute;
        bottom: 0px;
        display: flex;
        justify-content: space-between;
        color: #fff;
        width: 90%;
        &__btn {
          width: 50px;
          height: 35px;
          line-height: 35px;
          font-size: 12px;
          text-align: center;
          cursor: pointer;
          background-color: rgba($color: #000, $alpha: 0.3);
          &-active {
            background-color: $color-primary !important;
          }
        }
      }
    }
  }
}
</style>
